import Station from "./Station";
import RepairShop from "./repair/RepairShop";
import DispetcherCenter from "./DispetcherCenter";
import TrainCarPack from "./train/TrainCarPack";
import Train from "./train/Train";
import {ELECTRO_TYPE, LOCO_TYPE} from "../../constants/Constants";
import Locomotive from "./locomotives/Locomotive";
import ElectroLocomotive from "./locomotives/ElectroLocomotive";
import LocoGameCard from "./cards/LocoGameCard";
import {SecurityGameCard} from "./cards/SecurityGameCard";
import PathGameCard from "./cards/PathGameCard";
import StationGameCard from "./cards/StationGameCard";
import {GetTrainCarWeight} from "./Balance";
import agent from "../../agent";
import UtilsFunctions from "../../utils/UtilsFunctions";

class GameData {
  constructor() {
    this.isInited = false;
    this.onDataUpdated = () => {

    }
  }

  setData(data, teamId = null) {
    if (!Object.keys(data).length) return;

    if (window.lastTeamId === teamId) {
      let updated = [];

      if (this.debet && this.debet !== data.debet) updated.push(`${data.debet > this.debet ? "Получена" : "Выплачена"} дебиторская задолженность от клиентов в размере ${UtilsFunctions.toPrettyNumber(Math.abs(data.debet - this.debet))} руб.`)
      if (this.creditors && this.creditors !== data.creditors) updated.push(`Произведено ${data.creditors > this.creditors ? "начисление" : "списание"} кредиторской задолженности на ${UtilsFunctions.toPrettyNumber(Math.abs(this.creditors - data.creditors))} руб.`)
      if (this.credit && this.credit !== data.credit) updated.push(`Размер кредитов и займов изменен на ${UtilsFunctions.toPrettyNumber(Math.abs(this.credit - data.credit))} руб.`);
      if (updated.length) setTimeout(() => alert(updated.join("<br>"), false, true), 500);
    }

    this.isInited = true;
    this.state = data.state;
    this.teamState = data.teamState;
    this.day = data.day;
    this.cash = data.cash;
    this.totalProfit = data.totalProfit;
    this.fullCapital = data.fullCapital;

    this.debet = data.debet;
    this.startYearDebet = data.startYearDebet;
    this.credit = data.credit;
    this.startYearCreditors = data.startYearCreditors;
    this.creditCash = data.creditCash ?? 0;
    this.creditors = data.creditors;
    this.fixedAssets = data.fixedAssets;
    this.transportCash = data.transportCash ?? 0;
    this.exp = data.exp;
    this.nps = data.nps;
    this.year = data.year;
    this.securityLevel = data.securityLevel;
    this.stations = [];
    this.retainedEarnings = data.retainedEarnings;
    for (let i = 0; i < data.stations.length; i++) {
      let station = new Station();
      station.copy(data.stations[i]);
      this.stations.push(station);
    }
    this.repairShops = [];
    for (let i = 0; i < data.repairShops.length; i++) {
      let repairShop = new RepairShop();
      repairShop.copy(data.repairShops[i]);
      this.repairShops.push(repairShop);
    }
    let dispetcher = new DispetcherCenter();
    dispetcher.copy(data.dispetcher);
    this.dispetcher = dispetcher;
    this.paths = data.paths;
    this.locomotives = data.locomotives;

    // Удаляем "лишние" локо из ремонта – здоровые, но на последнем шаге починки
    for (let i = 0; i < this.repairShops.length; i++) {
      let repairShop = this.repairShops[i];

      if (repairShop.stages) {
        for (let j = 0; j < repairShop.stages[3].length; j++) {
          let locoID = repairShop.stages[3][j];
          let loco = this.getLocoById(locoID);

          if (loco.state === 10) this.repairShops[i].stages[3].splice(j, 1);
        }
      }
    }

    this.trainCarPacks = data.trainCarPacks;
    this.orderTrainCarPacks = data.orderTrainCarPacks ?? [];
    this.currentTrains = [];
    for (let i = 0; i < data.currentTrains.length; i++) {
      this.currentTrains.push(Object.assign(new Train(), data.currentTrains[i]));
    }
    this.currentOrders = data.currentOrders;
    this.thisYearOrder = data.thisYearOrder;
    this.currentStationCard = Object.assign(new StationGameCard(), data.currentStationCard) ?? null
    this.currentPathCard = Object.assign(new PathGameCard(), data.currentPathCard) ?? null;
    this.currentSecurityCard = Object.assign(new SecurityGameCard(), data.currentSecurityCard) ?? null;
    this.currentLocoCard = Object.assign(new LocoGameCard(), data.currentLocoCard) ?? null;

    this.totalBrigadeChips = data.totalBrigadeChips;
    this.unUsedBrigadeChips = data.unUsedBrigadeChips;
    this.contractorsExpenses = data.contractorsExpenses;
    this.partsExpanses = data.partsExpanses;
    this.securityExpanses = data.securityExpanses;
    this.otherExpanses = data.otherExpanses;
    this.otherRevenue = data.otherRevenue;
    this.currentArrivedTrainsCount = data.currentArrivedTrainsCount;
    this.deliveredTrainCarWeight = data.deliveredTrainCarWeight;
    this.bruttoDeliveredCarWeight = data.bruttoDeliveredCarWeight;
    this.thisYearLocosUsed = data.thisYearLocosUsed;
    this.currentFuelMetaData = data.currentFuelMetaData;

    this.currentFuelMetaData = data.currentFuelMetaData ?? null;
    this.tenders = data.tenders;
    this.rentBrigadeContract = data.rentBrigadeContract;
    this.rentLocoContract = data.rentLocoContract;
    this.rentStationPlaceContract = data.rentStationPlaceContract;
    this.rentTrainCarContract = data.rentTrainCarContract;
    this.isInvestComplete = data.isInvestComplete;
    this.isRentTrainCarActionComplete = data.isRentTrainCarActionComplete;
    this.startYearParts = data.startYearParts;
    this.boughtParts = data.boughtParts;
    this.brigadesExpanses = data.brigadesExpanses;
    this.dayOrderAmplifier = data.dayOrderAmplifier;

    if (teamId) {
      window.lastTeamId = teamId;
    }
  }

  getTotalBrigades() {
    let total_brigades = this.state !== 4 ? 0 : this.currentTrains.length;
    total_brigades += this.dispetcher.brigades;

    for (let i = 0; i < this.stations.length; i++) {
      let station = this.stations[i];
      total_brigades += station.brigades;
      total_brigades += station.locoBrigades;
    }
    for (let i = 0; i < this.repairShops.length; i++) {
      let repairShop = this.repairShops[i];
      total_brigades += repairShop.brigades;
    }
    return total_brigades
  }

  getCurrentCards() {
    // eslint-disable-next-line default-case
    switch (this.state) {
      case 2:
        if (this.currentStationCard != null) return [this.currentStationCard];
        break;
      case 5:
        return [this.currentPathCard, this.currentLocoCard, this.currentSecurityCard];
      default:
        break;
    }
    return [];
  }

  getPaths() {
    return this.paths;
  }

  getSecurityLevel() {
    return this.securityLevel;
  }

  getDispetcher() {
    return this.dispetcher;
  }

  getLocoById(id) {
    for (let i = 0; i < this.locomotives.length; i++) {
      if (this.locomotives[i].id === id) {
        return this.locomotives[i];
      }
    }
    return null;
  }

  removeBrigadeChips(type, id, value) {
    switch (type) {
      case "station":
        this.stations[id].brigadesChips -= value;
        break;
      case "repair":
        this.repairShops[id].brigadesChips -= value;
        break;
      case "dispetcher":
        this.dispetcher.brigadesChips -= value;
        break;
      default:
        break;
    }
    this.onDataUpdated();
  }

  addBreakdownChips(pathID) {
    let path = this.getPathByID(pathID);
    if (path.state <= 4) {
      path.breakDownChips += 3;
    } else {
      path.breakDownChips += 1;
    }
  }

  processLocoBreakdown(pathsId, stateCondition) {
    if (pathsId == null) {
      pathsId = this.paths.map(item => item.id);
    }

    for (let i = 0; i < pathsId.length; i++) {
      let trainIds = this.getTrainsIdsOnPath(pathsId);
      for (let j = 0; j < trainIds.length; j++) {
        let train = this.getTrainById(trainIds[j]);
        let locos = train.locomotives;
        for (let k = 0; k < locos.length; k++) {
          let loco = this.getLocoById(locos[k]);

          if (loco.isHot && loco.state < stateCondition) {
            loco.isBreakDown = true;
            loco.isHot = false;
          }
        }
      }
    }
  }

  processSecurityCards(pathsId, expanses, brigadeChips, breakDownChips) {
    for (let i = 0; i < pathsId.length; i++) {
      let path = this.getPathByID(pathsId[i]);
      path.endDayBreakdownChips += breakDownChips;
    }

  }

  getPathByID(id) {
    for (let i = 0; i < this.paths.length; i++) {
      if (this.paths[i].id === id) {
        return this.paths[i];
      }
    }
    return null;
  }

  getStationByID(id) {
    for (let i = 0; i < this.stations.length; i++) {
      if (this.stations[i].id === id) {
        return this.stations[i];
      }
    }
    return null;
  }

  getRepairShopByID(id) {
    for (let i = 0; i < this.repairShops.length; i++) {
      if (this.repairShops[i].id === id) {
        return this.repairShops[i];
      }
    }
    return null;
  }

  getRepairShopByType(type) {
    for (let i = 0; i < this.repairShops.length; i++) {
      if (this.repairShops[i].partsType === type) {
        return this.repairShops[i];
      }
    }
    return null;
  }

  getTrainById(id) {
    for (let i = 0; i < this.currentTrains.length; i++) {
      if (this.currentTrains[i].id === id) {
        return this.currentTrains[i];
      }
    }
    return null;
  }

  removeTrainById(id) {
    this.currentTrains = this.currentTrains.filter(train => train.id !== id);
  }

  addMoneyForOrder(money) {
    this.transportCash += 0.92 * money;
    this.debet += 0.08 * money;
    this.onDataUpdated();
  }

  addOrders(orders) {
    for (let i = 0; i < orders.length; i++) {
      this.currentOrders.push(orders[i]);
      let station = this.getStationByID(orders[i].fromId);
      let id = this.getOrderTrainCarPackId();
      this.orderTrainCarPacks.push(new TrainCarPack(id, 0, orders[i].trainCarType, orders[i].client, orders[i].code));
      station.orderTrainPacks.push(id);
    }
    this.onDataUpdated();
  }

  getTrainCarById(id) {
    for (let i = 0; i < this.trainCarPacks.length; i++) {
      if (this.trainCarPacks[i].id === id) {
        return this.trainCarPacks[i];
      }
    }
    return null;
  }

  getOrderTrainCarById(id) {

    for (let i = 0; i < this.orderTrainCarPacks.length; i++) {
      if (this.orderTrainCarPacks[i].id === id) {
        return this.orderTrainCarPacks[i];
      }
    }
    return null;
  }

  createTrainCar(trainCarCount, type, client, orderCode) {
    let pack = new TrainCarPack(this.getTrainCarPackId(), trainCarCount, type, client, orderCode);
    this.trainCarPacks.push(pack);
    return pack;
  }

  getTrainCarPackId() {
    return this.trainCarPacks.length === 0 ? 0 : Math.max.apply(Math, this.trainCarPacks.map(function (item) {
      return item.id
    })) + 1;
  }

  getOrderTrainCarPackId() {
    return this.orderTrainCarPacks.length === 0 ? 0 : Math.max.apply(Math, this.orderTrainCarPacks.map(function (item) {
      return item.id
    })) + 1;
  }

  addLoco(stationId, type) {
    switch (type) {
      default:
      case LOCO_TYPE:
        this.locomotives.push(new Locomotive(stationId, this.locomotives.length, 10));
        break;
      case ELECTRO_TYPE:
        this.locomotives.push(new ElectroLocomotive(stationId, this.locomotives.length, 10));
        break;
    }
  }

  locosOnGround() {
    let pathsWithTrains = this.paths.filter(el => el.LocoOnGround.length > 0);
    return pathsWithTrains.map(el => el.LocoOnGround).flat();
  }

  isLocoInAnyTrain(loco) {
    for (let i = 0; i < this.currentTrains.length; i++) {
      let train = this.currentTrains[i];
      if (train.locomotives.includes(loco.id)) return true;
    }
    return false;
  }

  isLocoOnGround(loco) {
    for (let i = 0; i < this.paths.length; i++) {
      let path = this.paths[i];
      if (path.LocoOnGround.includes(loco.id)) return true;
    }
    return false;
  }

  isTrainOnAnyPath(train) {
    for (let i = 0; i < this.paths.length; i++) {
      let path = this.paths[i];
      if (path.currentTrainIDs.includes(train.id)) return true;

    }
    return false;
  }

  getStationOrders(stationID) {
    return this.currentOrders.filter(x => x.fromId === stationID);
  }

  getStationLocomotives(stationID) {
    let locoShop = this.getRepairShopByType(LOCO_TYPE);
    let electroShop = this.getRepairShopByType(ELECTRO_TYPE);
    return this.locomotives.filter(x => x.parentStation === stationID && !this.isLocoInAnyTrain(x) && !this.isLocoOnGround(x) && !locoShop.isLocoRepairing(x) && !electroShop.isLocoRepairing(x));
  }

  getStationTrains(stationID) {
    return this.currentTrains.filter(x => x.parentStationID === stationID)
  }

  getCredit(value) {
    this.credit -= value;
    this.creditCash += value;
  }

  getFreeTrainID() {
    if (this.currentTrains.length === 0) return 0;
    return this.currentTrains[this.currentTrains.length - 1].id + 1;
  }

  getTrainsIdsOnPath(pathId) {
    let result = []
    let path = this.getPathByID(pathId);
    for (let i = 0; i < path.locoPlaces.length; i++) {
      let locoPlace = path.locoPlaces[i];
      let trainIds = locoPlace.currentTrainIDs;
      for (let j = 0; j < trainIds.length; j++) {
        result.push(trainIds[j]);
      }
    }
    return result;
  }

  createTrain(station, locos, trainCars, trainType, locoType) {

    for (let i = 0; i < trainCars.length; i++) {
      station.trainCarsPacks = station.trainCarsPacks.filter(x => x !== trainCars[i]);
    }
    let train = new Train(this.getFreeTrainID(), station.id, locos.map(x => x.id), trainCars, trainType, locoType);
    this.currentTrains.push(train);
  }

  freeTrain(train) {

    let station = this.getStationByID(train.parentStationID);
    this.currentTrains = this.currentTrains.filter(x => x !== train);
    for (let i = 0; i < train.carTrainPacks.length; i++) {
      station.trainCarsPacks.push(train.carTrainPacks[i]);
    }
    this.onDataUpdated();
  }

  getOrderWithCode(code) {
    for (let i = 0; i < this.currentOrders.length; i++) {
      if (this.currentOrders[i].code === code) {
        return this.currentOrders[i];
      }
    }
    return null;
  }

  getOrders() {
    let skip = ["У1", "У2", "К2", "С2", "П2"];
    return this.currentOrders.filter(el => el.weight !== 0 && !skip.includes(el.code));
  }

  getStations() {
    return this.stations;
  }

  getRepairShops() {
    return this.repairShops;
  }

  getRepairingLocomotives() {
    return this.locomotives.filter(x => x.isReparing);
  }

  isOrderFull(orderId) {
    let orderPack = this.getOrderTrainCarById(orderId);
    let order = this.getOrderWithCode(orderPack.orderCode);
    if (!order || order.isCompleted) return true;

    let packs = this.trainCarPacks.filter(x => order.code === x.orderCode);
    let weight = 0;
    for (const pack of packs) {
      weight += pack.trainCarCount * GetTrainCarWeight(pack.type);
    }

    const orderWeight = order.originalWeight ?? order.weight;
    return weight >= orderWeight;
  }

  getMaxOrderTrainCarsToLoad(orderId) {
    let orderPack = this.getOrderTrainCarById(orderId);
    let order = this.getOrderWithCode(orderPack.orderCode);
    if (!order || order.isCompleted) return true;

    let packs = this.trainCarPacks.filter(x => order.code === x.orderCode);
    let trainCarCount = 0;
    for (const pack of packs) {
      trainCarCount += pack.trainCarCount;
    }

    const orderWeight = order.originalWeight ?? order.weight;
    return Math.ceil(orderWeight / GetTrainCarWeight(orderPack.type) - trainCarCount);
  }

  commitInvestChanges(teamId, data, expanses) {
    this.cash -= expanses;
    let stationsData = data.stationData;
    let stationsSendData = [];
    for (let i = 0; i < stationsData.length; i++) {
      let station = this.getStationByID(stationsData[i].id);
      station.brigades += stationsData[i].brigades;
      station.locoBrigades += stationsData[i].locoBrigades;
      for (let j = 0; j < stationsData[i].loco; j++) {
        this.addLoco(stationsData[i].id, LOCO_TYPE);
      }
      for (let j = 0; j < stationsData[i].electro; j++) {
        this.addLoco(stationsData[i].id, ELECTRO_TYPE);
      }
      stationsSendData.push({
        stationId: stationsData[i].id,
        brigades: station.brigades,
        locoBrigades: station.locoBrigades,
        locoCount: [{"type": "electro", "count": stationsData[i].electro}, {
          "type": "loco", "count": stationsData[i].electro
        }]
      })
    }
    let repairDatas = data.repairData;
    let repairsSendData = [];
    for (let i = 0; i < repairDatas.length; i++) {
      let shop = this.getRepairShopByID(repairDatas[i].id);
      shop.brigades += repairDatas[i].brigades;
      shop.partsCount += repairDatas[i].spareParts;
      repairsSendData.push({
        repairShopId: repairDatas[i].id, brigades: shop.brigades, sparePartsCount: shop.partsCount
      })
    }
    this.dispetcher.brigades += data.dispetcherBrigades;
    agent.GamePlay.investComplete(teamId, {
      stationsData: stationsSendData, repairsData: repairsSendData, // TODO ТУТ СДЕЛАТЬ НОРМАЛЬНО
      dispetchersData: {brigadesCount: this.dispetcher.brigades}, securityLevel: data.securityLevel
    }, (r) => {
      console.log(r);

    });
    this.onDataUpdated();
  }

  getRentedBrigades(type, id) {
    let count = 0;
    for (let i = 0; i < this.rentBrigadeContract.length; i++) {
      let contract = this.rentBrigadeContract[i];
      if (contract.type === type && contract.id === id && contract.startDay + contract.days > this.day + this.year * 4) {
        count += contract.count;
      }
    }
    return count;
  }

  getRentedPlaces(stationId, clientId) {
    let count = 0;

    for (let i = 0; i < this.rentStationPlaceContract.length; i++) {
      let contract = this.rentStationPlaceContract[i];
      if (contract.station === stationId && contract.client === clientId.toString() && contract.startDay + contract.days > this.day + this.year * 4) {
        count += contract.count;
      }
    }
    return count;
  }

  isShouldShowRentBackWindow() {
    for (let i = 0; i < this.rentTrainCarContract.length; i++) {
      let contract = this.rentTrainCarContract[i];
      console.log(!contract.isCompleted && contract.startDay + contract.days <= this.day + this.year * 4);
      if (!contract.isCompleted && contract.startDay + contract.days <= this.day + this.year * 4) {
        return true;
      }
    }
    return false;
  }
}

const CreateGameData = (data) => {
  let gd = new GameData();
  gd.setData(data)
  return gd;
}
const CurrentGame = new GameData();
const CurrentModeratorGameDatas = {}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  CreateGameData, GameData, CurrentGame, CurrentModeratorGameDatas
};
